!(function (e, t) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define("VanillaContextMenu", [], t)
    : "object" == typeof exports
    ? (exports.VanillaContextMenu = t())
    : (e.VanillaContextMenu = t());
})(this, () =>
  (() => {
    var e = {
        550: (e, t, n) => {
          "use strict";
          n.d(t, { Z: () => s });
          var r = n(81),
            o = n.n(r),
            i = n(645),
            a = n.n(i)()(o());
          a.push([
            e.id,
            '',
            "",
          ]),
            (a.locals = {
              "context-menu": "PJsSKU2kCXjeIsVSdFoI",
              "context-menu--black-theme": "novl09c_yWe4MBqKpWyN",
              "context-menu--white-theme": "F5LtzLqHVYZuI1H_SR9q",
              visible: "ibAEWR3dINCWDsWq1G2P",
              "menu-item-icon": "gfl6YXq1tuGnYKHXwDHP",
              "nested-menu-arrow": "QkRci5U3hKz5RODdOkco",
            });
          const s = a;
        },
        645: (e) => {
          "use strict";
          e.exports = function (e) {
            var t = [];
            return (
              (t.toString = function () {
                return this.map(function (t) {
                  var n = "",
                    r = void 0 !== t[5];
                  return (
                    t[4] && (n += "@supports (".concat(t[4], ") {")),
                    t[2] && (n += "@media ".concat(t[2], " {")),
                    r &&
                      (n += "@layer".concat(
                        t[5].length > 0 ? " ".concat(t[5]) : "",
                        " {"
                      )),
                    (n += e(t)),
                    r && (n += "}"),
                    t[2] && (n += "}"),
                    t[4] && (n += "}"),
                    n
                  );
                }).join("");
              }),
              (t.i = function (e, n, r, o, i) {
                "string" == typeof e && (e = [[null, e, void 0]]);
                var a = {};
                if (r)
                  for (var s = 0; s < this.length; s++) {
                    var c = this[s][0];
                    null != c && (a[c] = !0);
                  }
                for (var l = 0; l < e.length; l++) {
                  var u = [].concat(e[l]);
                  (r && a[u[0]]) ||
                    (void 0 !== i &&
                      (void 0 === u[5] ||
                        (u[1] = "@layer"
                          .concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {")
                          .concat(u[1], "}")),
                      (u[5] = i)),
                    n &&
                      (u[2]
                        ? ((u[1] = "@media "
                            .concat(u[2], " {")
                            .concat(u[1], "}")),
                          (u[2] = n))
                        : (u[2] = n)),
                    o &&
                      (u[4]
                        ? ((u[1] = "@supports ("
                            .concat(u[4], ") {")
                            .concat(u[1], "}")),
                          (u[4] = o))
                        : (u[4] = "".concat(o))),
                    t.push(u));
                }
              }),
              t
            );
          };
        },
        81: (e) => {
          "use strict";
          e.exports = function (e) {
            return e[1];
          };
        },
        856: function (e) {
          e.exports = (function () {
            "use strict";
            function e(t) {
              return (
                (e =
                  "function" == typeof Symbol &&
                  "symbol" == typeof Symbol.iterator
                    ? function (e) {
                        return typeof e;
                      }
                    : function (e) {
                        return e &&
                          "function" == typeof Symbol &&
                          e.constructor === Symbol &&
                          e !== Symbol.prototype
                          ? "symbol"
                          : typeof e;
                      }),
                e(t)
              );
            }
            function t(e, n) {
              return (
                (t =
                  Object.setPrototypeOf ||
                  function (e, t) {
                    return (e.__proto__ = t), e;
                  }),
                t(e, n)
              );
            }
            function n(e, r, o) {
              return (
                (n = (function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return (
                      Boolean.prototype.valueOf.call(
                        Reflect.construct(Boolean, [], function () {})
                      ),
                      !0
                    );
                  } catch (e) {
                    return !1;
                  }
                })()
                  ? Reflect.construct
                  : function (e, n, r) {
                      var o = [null];
                      o.push.apply(o, n);
                      var i = new (Function.bind.apply(e, o))();
                      return r && t(i, r.prototype), i;
                    }),
                n.apply(null, arguments)
              );
            }
            function r(e) {
              return (
                (function (e) {
                  if (Array.isArray(e)) return o(e);
                })(e) ||
                (function (e) {
                  if (
                    ("undefined" != typeof Symbol &&
                      null != e[Symbol.iterator]) ||
                    null != e["@@iterator"]
                  )
                    return Array.from(e);
                })(e) ||
                (function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return o(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return (
                      "Object" === n &&
                        e.constructor &&
                        (n = e.constructor.name),
                      "Map" === n || "Set" === n
                        ? Array.from(e)
                        : "Arguments" === n ||
                          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                        ? o(e, t)
                        : void 0
                    );
                  }
                })(e) ||
                (function () {
                  throw new TypeError(
                    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                  );
                })()
              );
            }
            function o(e, t) {
              (null == t || t > e.length) && (t = e.length);
              for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
              return r;
            }
            var i = Object.hasOwnProperty,
              a = Object.setPrototypeOf,
              s = Object.isFrozen,
              c = Object.getPrototypeOf,
              l = Object.getOwnPropertyDescriptor,
              u = Object.freeze,
              p = Object.seal,
              m = Object.create,
              f = "undefined" != typeof Reflect && Reflect,
              d = f.apply,
              h = f.construct;
            d ||
              (d = function (e, t, n) {
                return e.apply(t, n);
              }),
              u ||
                (u = function (e) {
                  return e;
                }),
              p ||
                (p = function (e) {
                  return e;
                }),
              h ||
                (h = function (e, t) {
                  return n(e, r(t));
                });
            var y,
              g = M(Array.prototype.forEach),
              v = M(Array.prototype.pop),
              b = M(Array.prototype.push),
              x = M(String.prototype.toLowerCase),
              T = M(String.prototype.toString),
              w = M(String.prototype.match),
              E = M(String.prototype.replace),
              k = M(String.prototype.indexOf),
              S = M(String.prototype.trim),
              N = M(RegExp.prototype.test),
              A =
                ((y = TypeError),
                function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return h(y, t);
                });
            function M(e) {
              return function (t) {
                for (
                  var n = arguments.length,
                    r = new Array(n > 1 ? n - 1 : 0),
                    o = 1;
                  o < n;
                  o++
                )
                  r[o - 1] = arguments[o];
                return d(e, t, r);
              };
            }
            function C(e, t, n) {
              (n = n || x), a && a(e, null);
              for (var r = t.length; r--; ) {
                var o = t[r];
                if ("string" == typeof o) {
                  var i = n(o);
                  i !== o && (s(t) || (t[r] = i), (o = i));
                }
                e[o] = !0;
              }
              return e;
            }
            function O(e) {
              var t,
                n = m(null);
              for (t in e) !0 === d(i, e, [t]) && (n[t] = e[t]);
              return n;
            }
            function L(e, t) {
              for (; null !== e; ) {
                var n = l(e, t);
                if (n) {
                  if (n.get) return M(n.get);
                  if ("function" == typeof n.value) return M(n.value);
                }
                e = c(e);
              }
              return function (e) {
                return ;
              };
            }
            var _ = u([
                "a",
                "abbr",
                "acronym",
                "address",
                "area",
                "article",
                "aside",
                "audio",
                "b",
                "bdi",
                "bdo",
                "big",
                "blink",
                "blockquote",
                "body",
                "br",
                "button",
                "canvas",
                "caption",
                "center",
                "cite",
                "code",
                "col",
                "colgroup",
                "content",
                "data",
                "datalist",
                "dd",
                "decorator",
                "del",
                "details",
                "dfn",
                "dialog",
                "dir",
                "div",
                "dl",
                "dt",
                "element",
                "em",
                "fieldset",
                "figcaption",
                "figure",
                "font",
                "footer",
                "form",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "head",
                "header",
                "hgroup",
                "hr",
                "html",
                "i",
                "img",
                "input",
                "ins",
                "kbd",
                "label",
                "legend",
                "li",
                "main",
                "map",
                "mark",
                "marquee",
                "menu",
                "menuitem",
                "meter",
                "nav",
                "nobr",
                "ol",
                "optgroup",
                "option",
                "output",
                "p",
                "picture",
                "pre",
                "progress",
                "q",
                "rp",
                "rt",
                "ruby",
                "s",
                "samp",
                "section",
                "select",
                "shadow",
                "small",
                "source",
                "spacer",
                "span",
                "strike",
                "strong",
                "style",
                "sub",
                "summary",
                "sup",
                "table",
                "tbody",
                "td",
                "template",
                "textarea",
                "tfoot",
                "th",
                "thead",
                "time",
                "tr",
                "track",
                "tt",
                "u",
                "ul",
                "var",
                "video",
                "wbr",
              ]),
              I = u([
                "svg",
                "a",
                "altglyph",
                "altglyphdef",
                "altglyphitem",
                "animatecolor",
                "animatemotion",
                "animatetransform",
                "circle",
                "clippath",
                "defs",
                "desc",
                "ellipse",
                "filter",
                "font",
                "g",
                "glyph",
                "glyphref",
                "hkern",
                "image",
                "line",
                "lineargradient",
                "marker",
                "mask",
                "metadata",
                "mpath",
                "path",
                "pattern",
                "polygon",
                "polyline",
                "radialgradient",
                "rect",
                "stop",
                "style",
                "switch",
                "symbol",
                "text",
                "textpath",
                "title",
                "tref",
                "tspan",
                "view",
                "vkern",
              ]),
              D = u([
                "feBlend",
                "feColorMatrix",
                "feComponentTransfer",
                "feComposite",
                "feConvolveMatrix",
                "feDiffuseLighting",
                "feDisplacementMap",
                "feDistantLight",
                "feFlood",
                "feFuncA",
                "feFuncB",
                "feFuncG",
                "feFuncR",
                "feGaussianBlur",
                "feImage",
                "feMerge",
                "feMergeNode",
                "feMorphology",
                "feOffset",
                "fePointLight",
                "feSpecularLighting",
                "feSpotLight",
                "feTile",
                "feTurbulence",
              ]),
              R = u([
                "animate",
                "color-profile",
                "cursor",
                "discard",
                "fedropshadow",
                "font-face",
                "font-face-format",
                "font-face-name",
                "font-face-src",
                "font-face-uri",
                "foreignobject",
                "hatch",
                "hatchpath",
                "mesh",
                "meshgradient",
                "meshpatch",
                "meshrow",
                "missing-glyph",
                "script",
                "set",
                "solidcolor",
                "unknown",
                "use",
              ]),
              H = u([
                "math",
                "menclose",
                "merror",
                "mfenced",
                "mfrac",
                "mglyph",
                "mi",
                "mlabeledtr",
                "mmultiscripts",
                "mn",
                "mo",
                "mover",
                "mpadded",
                "mphantom",
                "mroot",
                "mrow",
                "ms",
                "mspace",
                "msqrt",
                "mstyle",
                "msub",
                "msup",
                "msubsup",
                "mtable",
                "mtd",
                "mtext",
                "mtr",
                "munder",
                "munderover",
              ]),
              F = u([
                "maction",
                "maligngroup",
                "malignmark",
                "mlongdiv",
                "mscarries",
                "mscarry",
                "msgroup",
                "mstack",
                "msline",
                "msrow",
                "semantics",
                "annotation",
                "annotation-xml",
                "mprescripts",
                "none",
              ]),
              j = u(["#text"]),
              W = u([
                "accept",
                "action",
                "align",
                "alt",
                "autocapitalize",
                "autocomplete",
                "autopictureinpicture",
                "autoplay",
                "background",
                "bgcolor",
                "border",
                "capture",
                "cellpadding",
                "cellspacing",
                "checked",
                "cite",
                "class",
                "clear",
                "color",
                "cols",
                "colspan",
                "controls",
                "controlslist",
                "coords",
                "crossorigin",
                "datetime",
                "decoding",
                "default",
                "dir",
                "disabled",
                "disablepictureinpicture",
                "disableremoteplayback",
                "download",
                "draggable",
                "enctype",
                "enterkeyhint",
                "face",
                "for",
                "headers",
                "height",
                "hidden",
                "high",
                "href",
                "hreflang",
                "id",
                "inputmode",
                "integrity",
                "ismap",
                "kind",
                "label",
                "lang",
                "list",
                "loading",
                "loop",
                "low",
                "max",
                "maxlength",
                "media",
                "method",
                "min",
                "minlength",
                "multiple",
                "muted",
                "name",
                "nonce",
                "noshade",
                "novalidate",
                "nowrap",
                "open",
                "optimum",
                "pattern",
                "placeholder",
                "playsinline",
                "poster",
                "preload",
                "pubdate",
                "radiogroup",
                "readonly",
                "rel",
                "required",
                "rev",
                "reversed",
                "role",
                "rows",
                "rowspan",
                "spellcheck",
                "scope",
                "selected",
                "shape",
                "size",
                "sizes",
                "span",
                "srclang",
                "start",
                "src",
                "srcset",
                "step",
                "style",
                "summary",
                "tabindex",
                "title",
                "translate",
                "type",
                "usemap",
                "valign",
                "value",
                "width",
                "xmlns",
                "slot",
              ]),
              U = u([
                "accent-height",
                "accumulate",
                "additive",
                "alignment-baseline",
                "ascent",
                "attributename",
                "attributetype",
                "azimuth",
                "basefrequency",
                "baseline-shift",
                "begin",
                "bias",
                "by",
                "class",
                "clip",
                "clippathunits",
                "clip-path",
                "clip-rule",
                "color",
                "color-interpolation",
                "color-interpolation-filters",
                "color-profile",
                "color-rendering",
                "cx",
                "cy",
                "d",
                "dx",
                "dy",
                "diffuseconstant",
                "direction",
                "display",
                "divisor",
                "dur",
                "edgemode",
                "elevation",
                "end",
                "fill",
                "fill-opacity",
                "fill-rule",
                "filter",
                "filterunits",
                "flood-color",
                "flood-opacity",
                "font-family",
                "font-size",
                "font-size-adjust",
                "font-stretch",
                "font-style",
                "font-variant",
                "font-weight",
                "fx",
                "fy",
                "g1",
                "g2",
                "glyph-name",
                "glyphref",
                "gradientunits",
                "gradienttransform",
                "height",
                "href",
                "id",
                "image-rendering",
                "in",
                "in2",
                "k",
                "k1",
                "k2",
                "k3",
                "k4",
                "kerning",
                "keypoints",
                "keysplines",
                "keytimes",
                "lang",
                "lengthadjust",
                "letter-spacing",
                "kernelmatrix",
                "kernelunitlength",
                "lighting-color",
                "local",
                "marker-end",
                "marker-mid",
                "marker-start",
                "markerheight",
                "markerunits",
                "markerwidth",
                "maskcontentunits",
                "maskunits",
                "max",
                "mask",
                "media",
                "method",
                "mode",
                "min",
                "name",
                "numoctaves",
                "offset",
                "operator",
                "opacity",
                "order",
                "orient",
                "orientation",
                "origin",
                "overflow",
                "paint-order",
                "path",
                "pathlength",
                "patterncontentunits",
                "patterntransform",
                "patternunits",
                "points",
                "preservealpha",
                "preserveaspectratio",
                "primitiveunits",
                "r",
                "rx",
                "ry",
                "radius",
                "refx",
                "refy",
                "repeatcount",
                "repeatdur",
                "restart",
                "result",
                "rotate",
                "scale",
                "seed",
                "shape-rendering",
                "specularconstant",
                "specularexponent",
                "spreadmethod",
                "startoffset",
                "stddeviation",
                "stitchtiles",
                "stop-color",
                "stop-opacity",
                "stroke-dasharray",
                "stroke-dashoffset",
                "stroke-linecap",
                "stroke-linejoin",
                "stroke-miterlimit",
                "stroke-opacity",
                "stroke",
                "stroke-width",
                "style",
                "surfacescale",
                "systemlanguage",
                "tabindex",
                "targetx",
                "targety",
                "transform",
                "transform-origin",
                "text-anchor",
                "text-decoration",
                "text-rendering",
                "textlength",
                "type",
                "u1",
                "u2",
                "unicode",
                "values",
                "viewbox",
                "visibility",
                "version",
                "vert-adv-y",
                "vert-origin-x",
                "vert-origin-y",
                "width",
                "word-spacing",
                "wrap",
                "writing-mode",
                "xchannelselector",
                "ychannelselector",
                "x",
                "x1",
                "x2",
                "xmlns",
                "y",
                "y1",
                "y2",
                "z",
                "zoomandpan",
              ]),
              z = u([
                "accent",
                "accentunder",
                "align",
                "bevelled",
                "close",
                "columnsalign",
                "columnlines",
                "columnspan",
                "denomalign",
                "depth",
                "dir",
                "display",
                "displaystyle",
                "encoding",
                "fence",
                "frame",
                "height",
                "href",
                "id",
                "largeop",
                "length",
                "linethickness",
                "lspace",
                "lquote",
                "mathbackground",
                "mathcolor",
                "mathsize",
                "mathvariant",
                "maxsize",
                "minsize",
                "movablelimits",
                "notation",
                "numalign",
                "open",
                "rowalign",
                "rowlines",
                "rowspacing",
                "rowspan",
                "rspace",
                "rquote",
                "scriptlevel",
                "scriptminsize",
                "scriptsizemultiplier",
                "selection",
                "separator",
                "separators",
                "stretchy",
                "subscriptshift",
                "supscriptshift",
                "symmetric",
                "voffset",
                "width",
                "xmlns",
              ]),
              P = u([
                "xlink:href",
                "xml:id",
                "xlink:title",
                "xml:space",
                "xmlns:xlink",
              ]),
              B = p(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
              q = p(/<%[\w\W]*|[\w\W]*%>/gm),
              G = p(/\${[\w\W]*}/gm),
              $ = p(/^data-[\-\w.\u00B7-\uFFFF]/),
              K = p(/^aria-[\-\w]+$/),
              Y = p(
                /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
              ),
              V = p(/^(?:\w+script|data):/i),
              X = p(
                /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
              ),
              J = p(/^html$/i),
              Z = function () {
                return "undefined" == typeof window ? null : window;
              },
              Q = function (t, n) {
                if ("object" !== e(t) || "function" != typeof t.createPolicy)
                  return null;
                var r = null,
                  o = "data-tt-policy-suffix";
                n.currentScript &&
                  n.currentScript.hasAttribute(o) &&
                  (r = n.currentScript.getAttribute(o));
                var i = "dompurify" + (r ? "#" + r : "");
                try {
                  return t.createPolicy(i, {
                    createHTML: function (e) {
                      return e;
                    },
                    createScriptURL: function (e) {
                      return e;
                    },
                  });
                } catch (e) {
                  return (
                    null
                  );
                }
              };
            return (function t() {
              var n =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : Z(),
                o = function (e) {
                  return t(e);
                };
              if (
                ((o.version = "2.4.3"),
                (o.removed = []),
                !n || !n.document || 9 !== n.document.nodeType)
              )
                return (o.isSupported = !1), o;
              var i = n.document,
                a = n.document,
                s = n.DocumentFragment,
                c = n.HTMLTemplateElement,
                l = n.Node,
                p = n.Element,
                m = n.NodeFilter,
                f = n.NamedNodeMap,
                d = void 0 === f ? n.NamedNodeMap || n.MozNamedAttrMap : f,
                h = n.HTMLFormElement,
                y = n.DOMParser,
                M = n.trustedTypes,
                ee = p.prototype,
                te = L(ee, "cloneNode"),
                ne = L(ee, "nextSibling"),
                re = L(ee, "childNodes"),
                oe = L(ee, "parentNode");
              if ("function" == typeof c) {
                var ie = a.createElement("template");
                ie.content &&
                  ie.content.ownerDocument &&
                  (a = ie.content.ownerDocument);
              }
              var ae = Q(M, i),
                se = ae ? ae.createHTML("") : "",
                ce = a,
                le = ce.implementation,
                ue = ce.createNodeIterator,
                pe = ce.createDocumentFragment,
                me = ce.getElementsByTagName,
                fe = i.importNode,
                de = {};
              try {
                de = O(a).documentMode ? a.documentMode : {};
              } catch (e) {}
              var he = {};
              o.isSupported =
                "function" == typeof oe &&
                le &&
                void 0 !== le.createHTMLDocument &&
                9 !== de;
              var ye,
                ge,
                ve = B,
                be = q,
                xe = G,
                Te = $,
                we = K,
                Ee = V,
                ke = X,
                Se = Y,
                Ne = null,
                Ae = C({}, [].concat(r(_), r(I), r(D), r(H), r(j))),
                Me = null,
                Ce = C({}, [].concat(r(W), r(U), r(z), r(P))),
                Oe = Object.seal(
                  Object.create(null, {
                    tagNameCheck: {
                      writable: !0,
                      configurable: !1,
                      enumerable: !0,
                      value: null,
                    },
                    attributeNameCheck: {
                      writable: !0,
                      configurable: !1,
                      enumerable: !0,
                      value: null,
                    },
                    allowCustomizedBuiltInElements: {
                      writable: !0,
                      configurable: !1,
                      enumerable: !0,
                      value: !1,
                    },
                  })
                ),
                Le = null,
                _e = null,
                Ie = !0,
                De = !0,
                Re = !1,
                He = !1,
                Fe = !1,
                je = !1,
                We = !1,
                Ue = !1,
                ze = !1,
                Pe = !1,
                Be = !0,
                qe = !1,
                Ge = !0,
                $e = !1,
                Ke = {},
                Ye = null,
                Ve = C({}, [
                  "annotation-xml",
                  "audio",
                  "colgroup",
                  "desc",
                  "foreignobject",
                  "head",
                  "iframe",
                  "math",
                  "mi",
                  "mn",
                  "mo",
                  "ms",
                  "mtext",
                  "noembed",
                  "noframes",
                  "noscript",
                  "plaintext",
                  "script",
                  "style",
                  "svg",
                  "template",
                  "thead",
                  "title",
                  "video",
                  "xmp",
                ]),
                Xe = null,
                Je = C({}, [
                  "audio",
                  "video",
                  "img",
                  "source",
                  "image",
                  "track",
                ]),
                Ze = null,
                Qe = C({}, [
                  "alt",
                  "class",
                  "for",
                  "id",
                  "label",
                  "name",
                  "pattern",
                  "placeholder",
                  "role",
                  "summary",
                  "title",
                  "value",
                  "style",
                  "xmlns",
                ]),
                et = "http://www.w3.org/1998/Math/MathML",
                tt = "http://www.w3.org/2000/svg",
                nt = "http://www.w3.org/1999/xhtml",
                rt = nt,
                ot = !1,
                it = null,
                at = C({}, [et, tt, nt], T),
                st = ["application/xhtml+xml", "text/html"],
                ct = null,
                lt = a.createElement("form"),
                ut = function (e) {
                  return e instanceof RegExp || e instanceof Function;
                },
                pt = function (t) {
                  (ct && ct === t) ||
                    ((t && "object" === e(t)) || (t = {}),
                    (t = O(t)),
                    (ye = ye =
                      -1 === st.indexOf(t.PARSER_MEDIA_TYPE)
                        ? "text/html"
                        : t.PARSER_MEDIA_TYPE),
                    (ge = "application/xhtml+xml" === ye ? T : x),
                    (Ne = "ALLOWED_TAGS" in t ? C({}, t.ALLOWED_TAGS, ge) : Ae),
                    (Me = "ALLOWED_ATTR" in t ? C({}, t.ALLOWED_ATTR, ge) : Ce),
                    (it =
                      "ALLOWED_NAMESPACES" in t
                        ? C({}, t.ALLOWED_NAMESPACES, T)
                        : at),
                    (Ze =
                      "ADD_URI_SAFE_ATTR" in t
                        ? C(O(Qe), t.ADD_URI_SAFE_ATTR, ge)
                        : Qe),
                    (Xe =
                      "ADD_DATA_URI_TAGS" in t
                        ? C(O(Je), t.ADD_DATA_URI_TAGS, ge)
                        : Je),
                    (Ye =
                      "FORBID_CONTENTS" in t
                        ? C({}, t.FORBID_CONTENTS, ge)
                        : Ve),
                    (Le = "FORBID_TAGS" in t ? C({}, t.FORBID_TAGS, ge) : {}),
                    (_e = "FORBID_ATTR" in t ? C({}, t.FORBID_ATTR, ge) : {}),
                    (Ke = "USE_PROFILES" in t && t.USE_PROFILES),
                    (Ie = !1 !== t.ALLOW_ARIA_ATTR),
                    (De = !1 !== t.ALLOW_DATA_ATTR),
                    (Re = t.ALLOW_UNKNOWN_PROTOCOLS || !1),
                    (He = t.SAFE_FOR_TEMPLATES || !1),
                    (Fe = t.WHOLE_DOCUMENT || !1),
                    (Ue = t.RETURN_DOM || !1),
                    (ze = t.RETURN_DOM_FRAGMENT || !1),
                    (Pe = t.RETURN_TRUSTED_TYPE || !1),
                    (We = t.FORCE_BODY || !1),
                    (Be = !1 !== t.SANITIZE_DOM),
                    (qe = t.SANITIZE_NAMED_PROPS || !1),
                    (Ge = !1 !== t.KEEP_CONTENT),
                    ($e = t.IN_PLACE || !1),
                    (Se = t.ALLOWED_URI_REGEXP || Se),
                    (rt = t.NAMESPACE || nt),
                    t.CUSTOM_ELEMENT_HANDLING &&
                      ut(t.CUSTOM_ELEMENT_HANDLING.tagNameCheck) &&
                      (Oe.tagNameCheck =
                        t.CUSTOM_ELEMENT_HANDLING.tagNameCheck),
                    t.CUSTOM_ELEMENT_HANDLING &&
                      ut(t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) &&
                      (Oe.attributeNameCheck =
                        t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),
                    t.CUSTOM_ELEMENT_HANDLING &&
                      "boolean" ==
                        typeof t.CUSTOM_ELEMENT_HANDLING
                          .allowCustomizedBuiltInElements &&
                      (Oe.allowCustomizedBuiltInElements =
                        t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),
                    He && (De = !1),
                    ze && (Ue = !0),
                    Ke &&
                      ((Ne = C({}, r(j))),
                      (Me = []),
                      !0 === Ke.html && (C(Ne, _), C(Me, W)),
                      !0 === Ke.svg && (C(Ne, I), C(Me, U), C(Me, P)),
                      !0 === Ke.svgFilters && (C(Ne, D), C(Me, U), C(Me, P)),
                      !0 === Ke.mathMl && (C(Ne, H), C(Me, z), C(Me, P))),
                    t.ADD_TAGS &&
                      (Ne === Ae && (Ne = O(Ne)), C(Ne, t.ADD_TAGS, ge)),
                    t.ADD_ATTR &&
                      (Me === Ce && (Me = O(Me)), C(Me, t.ADD_ATTR, ge)),
                    t.ADD_URI_SAFE_ATTR && C(Ze, t.ADD_URI_SAFE_ATTR, ge),
                    t.FORBID_CONTENTS &&
                      (Ye === Ve && (Ye = O(Ye)), C(Ye, t.FORBID_CONTENTS, ge)),
                    Ge && (Ne["#text"] = !0),
                    Fe && C(Ne, ["html", "head", "body"]),
                    Ne.table && (C(Ne, ["tbody"]), delete Le.tbody),
                    u && u(t),
                    (ct = t));
                },
                mt = C({}, ["mi", "mo", "mn", "ms", "mtext"]),
                ft = C({}, [
                  "foreignobject",
                  "desc",
                  "title",
                  "annotation-xml",
                ]),
                dt = C({}, ["title", "style", "font", "a", "script"]),
                ht = C({}, I);
              C(ht, D), C(ht, R);
              var yt = C({}, H);
              C(yt, F);
              var gt = function (e) {
                  b(o.removed, { element: e });
                  try {
                    e.parentNode.removeChild(e);
                  } catch (t) {
                    try {
                      e.outerHTML = se;
                    } catch (t) {
                      e.remove();
                    }
                  }
                },
                vt = function (e, t) {
                  try {
                    b(o.removed, { attribute: t.getAttributeNode(e), from: t });
                  } catch (e) {
                    b(o.removed, { attribute: null, from: t });
                  }
                  if ((t.removeAttribute(e), "is" === e && !Me[e]))
                    if (Ue || ze)
                      try {
                        gt(t);
                      } catch (e) {}
                    else
                      try {
                        t.setAttribute(e, "");
                      } catch (e) {}
                },
                bt = function (e) {
                  var t, n;
                  if (We) e = "<remove></remove>" + e;
                  else {
                    var r = w(e, /^[\r\n\t ]+/);
                    n = r && r[0];
                  }
                  "application/xhtml+xml" === ye &&
                    rt === nt &&
                    (e =
                      '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' +
                      e +
                      "</body></html>");
                  var o = ae ? ae.createHTML(e) : e;
                  if (rt === nt)
                    try {
                      t = new y().parseFromString(o, ye);
                    } catch (e) {}
                  if (!t || !t.documentElement) {
                    t = le.createDocument(rt, "template", null);
                    try {
                      t.documentElement.innerHTML = ot ? se : o;
                    } catch (e) {}
                  }
                  var i = t.body || t.documentElement;
                  return (
                    e &&
                      n &&
                      i.insertBefore(
                        a.createTextNode(n),
                        i.childNodes[0] || null
                      ),
                    rt === nt
                      ? me.call(t, Fe ? "html" : "body")[0]
                      : Fe
                      ? t.documentElement
                      : i
                  );
                },
                xt = function (e) {
                  return ue.call(
                    e.ownerDocument || e,
                    e,
                    m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT,
                    null,
                    !1
                  );
                },
                Tt = function (t) {
                  return "object" === e(l)
                    ? t instanceof l
                    : t &&
                        "object" === e(t) &&
                        "number" == typeof t.nodeType &&
                        "string" == typeof t.nodeName;
                },
                wt = function (e, t, n) {
                  he[e] &&
                    g(he[e], function (e) {
                      e.call(o, t, n, ct);
                    });
                },
                Et = function (e) {
                  var t, n;
                  if (
                    (wt("beforeSanitizeElements", e, null),
                    (n = e) instanceof h &&
                      ("string" != typeof n.nodeName ||
                        "string" != typeof n.textContent ||
                        "function" != typeof n.removeChild ||
                        !(n.attributes instanceof d) ||
                        "function" != typeof n.removeAttribute ||
                        "function" != typeof n.setAttribute ||
                        "string" != typeof n.namespaceURI ||
                        "function" != typeof n.insertBefore ||
                        "function" != typeof n.hasChildNodes))
                  )
                    return gt(e), !0;
                  if (N(/[\u0080-\uFFFF]/, e.nodeName)) return gt(e), !0;
                  var r = ge(e.nodeName);
                  if (
                    (wt("uponSanitizeElement", e, {
                      tagName: r,
                      allowedTags: Ne,
                    }),
                    e.hasChildNodes() &&
                      !Tt(e.firstElementChild) &&
                      (!Tt(e.content) || !Tt(e.content.firstElementChild)) &&
                      N(/<[/\w]/g, e.innerHTML) &&
                      N(/<[/\w]/g, e.textContent))
                  )
                    return gt(e), !0;
                  if ("select" === r && N(/<template/i, e.innerHTML))
                    return gt(e), !0;
                  if (!Ne[r] || Le[r]) {
                    if (!Le[r] && St(r)) {
                      if (
                        Oe.tagNameCheck instanceof RegExp &&
                        N(Oe.tagNameCheck, r)
                      )
                        return !1;
                      if (
                        Oe.tagNameCheck instanceof Function &&
                        Oe.tagNameCheck(r)
                      )
                        return !1;
                    }
                    if (Ge && !Ye[r]) {
                      var i = oe(e) || e.parentNode,
                        a = re(e) || e.childNodes;
                      if (a && i)
                        for (var s = a.length - 1; s >= 0; --s)
                          i.insertBefore(te(a[s], !0), ne(e));
                    }
                    return gt(e), !0;
                  }
                  return e instanceof p &&
                    !(function (e) {
                      var t = oe(e);
                      (t && t.tagName) ||
                        (t = { namespaceURI: rt, tagName: "template" });
                      var n = x(e.tagName),
                        r = x(t.tagName);
                      return (
                        !!it[e.namespaceURI] &&
                        (e.namespaceURI === tt
                          ? t.namespaceURI === nt
                            ? "svg" === n
                            : t.namespaceURI === et
                            ? "svg" === n && ("annotation-xml" === r || mt[r])
                            : Boolean(ht[n])
                          : e.namespaceURI === et
                          ? t.namespaceURI === nt
                            ? "math" === n
                            : t.namespaceURI === tt
                            ? "math" === n && ft[r]
                            : Boolean(yt[n])
                          : e.namespaceURI === nt
                          ? !(t.namespaceURI === tt && !ft[r]) &&
                            !(t.namespaceURI === et && !mt[r]) &&
                            !yt[n] &&
                            (dt[n] || !ht[n])
                          : !(
                              "application/xhtml+xml" !== ye ||
                              !it[e.namespaceURI]
                            ))
                      );
                    })(e)
                    ? (gt(e), !0)
                    : ("noscript" !== r && "noembed" !== r) ||
                      !N(/<\/no(script|embed)/i, e.innerHTML)
                    ? (He &&
                        3 === e.nodeType &&
                        ((t = e.textContent),
                        (t = E(t, ve, " ")),
                        (t = E(t, be, " ")),
                        (t = E(t, xe, " ")),
                        e.textContent !== t &&
                          (b(o.removed, { element: e.cloneNode() }),
                          (e.textContent = t))),
                      wt("afterSanitizeElements", e, null),
                      !1)
                    : (gt(e), !0);
                },
                kt = function (e, t, n) {
                  if (Be && ("id" === t || "name" === t) && (n in a || n in lt))
                    return !1;
                  if (De && !_e[t] && N(Te, t));
                  else if (Ie && N(we, t));
                  else if (!Me[t] || _e[t]) {
                    if (
                      !(
                        (St(e) &&
                          ((Oe.tagNameCheck instanceof RegExp &&
                            N(Oe.tagNameCheck, e)) ||
                            (Oe.tagNameCheck instanceof Function &&
                              Oe.tagNameCheck(e))) &&
                          ((Oe.attributeNameCheck instanceof RegExp &&
                            N(Oe.attributeNameCheck, t)) ||
                            (Oe.attributeNameCheck instanceof Function &&
                              Oe.attributeNameCheck(t)))) ||
                        ("is" === t &&
                          Oe.allowCustomizedBuiltInElements &&
                          ((Oe.tagNameCheck instanceof RegExp &&
                            N(Oe.tagNameCheck, n)) ||
                            (Oe.tagNameCheck instanceof Function &&
                              Oe.tagNameCheck(n))))
                      )
                    )
                      return !1;
                  } else if (Ze[t]);
                  else if (N(Se, E(n, ke, "")));
                  else if (
                    ("src" !== t && "xlink:href" !== t && "href" !== t) ||
                    "script" === e ||
                    0 !== k(n, "data:") ||
                    !Xe[e]
                  )
                    if (Re && !N(Ee, E(n, ke, "")));
                    else if (n) return !1;
                  return !0;
                },
                St = function (e) {
                  return e.indexOf("-") > 0;
                },
                Nt = function (t) {
                  var n, r, i, a;
                  wt("beforeSanitizeAttributes", t, null);
                  var s = t.attributes;
                  if (s) {
                    var c = {
                      attrName: "",
                      attrValue: "",
                      keepAttr: !0,
                      allowedAttributes: Me,
                    };
                    for (a = s.length; a--; ) {
                      var l = (n = s[a]),
                        u = l.name,
                        p = l.namespaceURI;
                      if (
                        ((r = "value" === u ? n.value : S(n.value)),
                        (i = ge(u)),
                        (c.attrName = i),
                        (c.attrValue = r),
                        (c.keepAttr = !0),
                        (c.forceKeepAttr = void 0),
                        wt("uponSanitizeAttribute", t, c),
                        (r = c.attrValue),
                        !c.forceKeepAttr && (vt(u, t), c.keepAttr))
                      )
                        if (N(/\/>/i, r)) vt(u, t);
                        else {
                          He &&
                            ((r = E(r, ve, " ")),
                            (r = E(r, be, " ")),
                            (r = E(r, xe, " ")));
                          var m = ge(t.nodeName);
                          if (kt(m, i, r)) {
                            if (
                              (!qe ||
                                ("id" !== i && "name" !== i) ||
                                (vt(u, t), (r = "user-content-" + r)),
                              ae &&
                                "object" === e(M) &&
                                "function" == typeof M.getAttributeType)
                            )
                              if (p);
                              else
                                switch (M.getAttributeType(m, i)) {
                                  case "TrustedHTML":
                                    r = ae.createHTML(r);
                                    break;
                                  case "TrustedScriptURL":
                                    r = ae.createScriptURL(r);
                                }
                            try {
                              p
                                ? t.setAttributeNS(p, u, r)
                                : t.setAttribute(u, r),
                                v(o.removed);
                            } catch (e) {}
                          }
                        }
                    }
                    wt("afterSanitizeAttributes", t, null);
                  }
                },
                At = function e(t) {
                  var n,
                    r = xt(t);
                  for (
                    wt("beforeSanitizeShadowDOM", t, null);
                    (n = r.nextNode());

                  )
                    wt("uponSanitizeShadowNode", n, null),
                      Et(n) || (n.content instanceof s && e(n.content), Nt(n));
                  wt("afterSanitizeShadowDOM", t, null);
                };
              return (
                (o.sanitize = function (t) {
                  var r,
                    a,
                    c,
                    u,
                    p,
                    m =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {};
                  if (
                    ((ot = !t) && (t = "\x3c!--\x3e"),
                    "string" != typeof t && !Tt(t))
                  ) {
                    if ("function" != typeof t.toString)
                      throw A("toString is not a function");
                    if ("string" != typeof (t = t.toString()))
                      throw A("dirty is not a string, aborting");
                  }
                  if (!o.isSupported) {
                    if (
                      "object" === e(n.toStaticHTML) ||
                      "function" == typeof n.toStaticHTML
                    ) {
                      if ("string" == typeof t) return n.toStaticHTML(t);
                      if (Tt(t)) return n.toStaticHTML(t.outerHTML);
                    }
                    return t;
                  }
                  if (
                    (je || pt(m),
                    (o.removed = []),
                    "string" == typeof t && ($e = !1),
                    $e)
                  ) {
                    if (t.nodeName) {
                      var f = ge(t.nodeName);
                      if (!Ne[f] || Le[f])
                        throw A(
                          "root node is forbidden and cannot be sanitized in-place"
                        );
                    }
                  } else if (t instanceof l)
                    (1 ===
                      (a = (r = bt("\x3c!----\x3e")).ownerDocument.importNode(
                        t,
                        !0
                      )).nodeType &&
                      "BODY" === a.nodeName) ||
                    "HTML" === a.nodeName
                      ? (r = a)
                      : r.appendChild(a);
                  else {
                    if (!Ue && !He && !Fe && -1 === t.indexOf("<"))
                      return ae && Pe ? ae.createHTML(t) : t;
                    if (!(r = bt(t))) return Ue ? null : Pe ? se : "";
                  }
                  r && We && gt(r.firstChild);
                  for (var d = xt($e ? t : r); (c = d.nextNode()); )
                    (3 === c.nodeType && c === u) ||
                      Et(c) ||
                      (c.content instanceof s && At(c.content), Nt(c), (u = c));
                  if (((u = null), $e)) return t;
                  if (Ue) {
                    if (ze)
                      for (p = pe.call(r.ownerDocument); r.firstChild; )
                        p.appendChild(r.firstChild);
                    else p = r;
                    return Me.shadowroot && (p = fe.call(i, p, !0)), p;
                  }
                  var h = Fe ? r.outerHTML : r.innerHTML;
                  return (
                    Fe &&
                      Ne["!doctype"] &&
                      r.ownerDocument &&
                      r.ownerDocument.doctype &&
                      r.ownerDocument.doctype.name &&
                      N(J, r.ownerDocument.doctype.name) &&
                      (h =
                        "<!DOCTYPE " +
                        r.ownerDocument.doctype.name +
                        ">\n" +
                        h),
                    He &&
                      ((h = E(h, ve, " ")),
                      (h = E(h, be, " ")),
                      (h = E(h, xe, " "))),
                    ae && Pe ? ae.createHTML(h) : h
                  );
                }),
                (o.setConfig = function (e) {
                  pt(e), (je = !0);
                }),
                (o.clearConfig = function () {
                  (ct = null), (je = !1);
                }),
                (o.isValidAttribute = function (e, t, n) {
                  ct || pt({});
                  var r = ge(e),
                    o = ge(t);
                  return kt(r, o, n);
                }),
                (o.addHook = function (e, t) {
                  "function" == typeof t &&
                    ((he[e] = he[e] || []), b(he[e], t));
                }),
                (o.removeHook = function (e) {
                  if (he[e]) return v(he[e]);
                }),
                (o.removeHooks = function (e) {
                  he[e] && (he[e] = []);
                }),
                (o.removeAllHooks = function () {
                  he = {};
                }),
                o
              );
            })();
          })();
        },
        138: (e, t, n) => {
          var r = n(55);
          e.exports = function (e) {
            var t,
              n = "",
              o = e || {};
            return (
              function (e, o) {
                (n =
                  n +
                  "<div" +
                  r.attr(
                    "class",
                    r.classes([`${o["context-menu"]}`], [!0]),
                    !1,
                    !0
                  ) +
                  "> "),
                  function () {
                    var i = e;
                    if ("number" == typeof i.length)
                      for (var a = 0, s = i.length; a < s; a++)
                        "hr" === (c = i[a])
                          ? (n += "<hr>")
                          : ((n =
                              n +
                              "<div" +
                              r.attr(
                                "id",
                                `context-menu-item-${c._id}`,
                                !0,
                                !0
                              ) +
                              "> "),
                            (c.iconClass || c.iconHTML) &&
                              ((n =
                                n +
                                "<span" +
                                r.attr(
                                  "class",
                                  r.classes([`${o["menu-item-icon"]}`], [!0]),
                                  !1,
                                  !0
                                ) +
                                ">"),
                              c.iconClass &&
                                (n =
                                  n +
                                  "<i" +
                                  r.attr(
                                    "class",
                                    r.classes([`${c.iconClass}`], [!0]),
                                    !1,
                                    !0
                                  ) +
                                  "></i>"),
                              c.iconHTML &&
                                (n += null == (t = c.iconHTML) ? "" : t),
                              (n += "</span>")),
                            (n =
                              n +
                              "<span>" +
                              r.escape(null == (t = c.label) ? "" : t) +
                              "</span>"),
                            c.nestedMenu &&
                              (n =
                                n +
                                "<span" +
                                r.attr(
                                  "class",
                                  r.classes(
                                    [`${o["nested-menu-arrow"]}`],
                                    [!0]
                                  ),
                                  !1,
                                  !0
                                ) +
                                ">&#x203A;</span>"),
                            (n += "</div>"));
                    else
                      for (var a in ((s = 0), i)) {
                        var c;
                        s++,
                          "hr" === (c = i[a])
                            ? (n += "<hr>")
                            : ((n =
                                n +
                                "<div" +
                                r.attr(
                                  "id",
                                  `context-menu-item-${c._id}`,
                                  !0,
                                  !0
                                ) +
                                "> "),
                              (c.iconClass || c.iconHTML) &&
                                ((n =
                                  n +
                                  "<span" +
                                  r.attr(
                                    "class",
                                    r.classes([`${o["menu-item-icon"]}`], [!0]),
                                    !1,
                                    !0
                                  ) +
                                  ">"),
                                c.iconClass &&
                                  (n =
                                    n +
                                    "<i" +
                                    r.attr(
                                      "class",
                                      r.classes([`${c.iconClass}`], [!0]),
                                      !1,
                                      !0
                                    ) +
                                    "></i>"),
                                c.iconHTML &&
                                  (n += null == (t = c.iconHTML) ? "" : t),
                                (n += "</span>")),
                              (n =
                                n +
                                "<span>" +
                                r.escape(null == (t = c.label) ? "" : t) +
                                "</span>"),
                              c.nestedMenu &&
                                (n =
                                  n +
                                  "<span" +
                                  r.attr(
                                    "class",
                                    r.classes(
                                      [`${o["nested-menu-arrow"]}`],
                                      [!0]
                                    ),
                                    !1,
                                    !0
                                  ) +
                                  ">&#x203A;</span>"),
                              (n += "</div>"));
                      }
                  }.call(this),
                  (n += "</div>");
              }.call(
                this,
                "menuItems" in o
                  ? o.menuItems
                  : "undefined" != typeof menuItems
                  ? menuItems
                  : void 0,
                "style" in o
                  ? o.style
                  : "undefined" != typeof style
                  ? style
                  : void 0
              ),
              n
            );
          };
        },
        55: (e, t, n) => {
          "use strict";
          var r = Object.prototype.hasOwnProperty;
          function o(e, t) {
            return Array.isArray(e)
              ? (function (e, t) {
                  for (
                    var n, r = "", i = "", a = Array.isArray(t), s = 0;
                    s < e.length;
                    s++
                  )
                    (n = o(e[s])) &&
                      (a && t[s] && (n = c(n)), (r = r + i + n), (i = " "));
                  return r;
                })(e, t)
              : e && "object" == typeof e
              ? (function (e) {
                  var t = "",
                    n = "";
                  for (var o in e)
                    o && e[o] && r.call(e, o) && ((t = t + n + o), (n = " "));
                  return t;
                })(e)
              : e || "";
          }
          function i(e) {
            if (!e) return "";
            if ("object" == typeof e) {
              var t = "";
              for (var n in e) r.call(e, n) && (t = t + n + ":" + e[n] + ";");
              return t;
            }
            return e + "";
          }
          function a(e, t, n, r) {
            if (
              !1 === t ||
              null == t ||
              (!t && ("class" === e || "style" === e))
            )
              return "";
            if (!0 === t) return " " + (r ? e : e + '="' + e + '"');
            var o = typeof t;
            return (
              ("object" !== o && "function" !== o) ||
                "function" != typeof t.toJSON ||
                (t = t.toJSON()),
              "string" == typeof t ||
              ((t = JSON.stringify(t)), n || -1 === t.indexOf('"'))
                ? (n && (t = c(t)), " " + e + '="' + t + '"')
                : " " + e + "='" + t.replace(/'/g, "&#39;") + "'"
            );
          }
          (t.merge = function e(t, n) {
            if (1 === arguments.length) {
              for (var r = t[0], o = 1; o < t.length; o++) r = e(r, t[o]);
              return r;
            }
            for (var a in n)
              if ("class" === a) {
                var s = t[a] || [];
                t[a] = (Array.isArray(s) ? s : [s]).concat(n[a] || []);
              } else if ("style" === a) {
                s = (s = i(t[a])) && ";" !== s[s.length - 1] ? s + ";" : s;
                var c = i(n[a]);
                (c = c && ";" !== c[c.length - 1] ? c + ";" : c),
                  (t[a] = s + c);
              } else t[a] = n[a];
            return t;
          }),
            (t.classes = o),
            (t.style = i),
            (t.attr = a),
            (t.attrs = function (e, t) {
              var n = "";
              for (var s in e)
                if (r.call(e, s)) {
                  var c = e[s];
                  if ("class" === s) {
                    n = a(s, (c = o(c)), !1, t) + n;
                    continue;
                  }
                  "style" === s && (c = i(c)), (n += a(s, c, !1, t));
                }
              return n;
            });
          var s = /["&<>]/;
          function c(e) {
            var t = "" + e,
              n = s.exec(t);
            if (!n) return e;
            var r,
              o,
              i,
              a = "";
            for (r = n.index, o = 0; r < t.length; r++) {
              switch (t.charCodeAt(r)) {
                case 34:
                  i = "&quot;";
                  break;
                case 38:
                  i = "&amp;";
                  break;
                case 60:
                  i = "&lt;";
                  break;
                case 62:
                  i = "&gt;";
                  break;
                default:
                  continue;
              }
              o !== r && (a += t.substring(o, r)), (o = r + 1), (a += i);
            }
            return o !== r ? a + t.substring(o, r) : a;
          }
          (t.escape = c),
            (t.rethrow = function e(t, r, o, i) {
              if (!(t instanceof Error)) throw t;
              if (!(("undefined" == typeof window && r) || i))
                throw ((t.message += " on line " + o), t);
              var a, s, c, l;
              try {
                (i = i || n(835).readFileSync(r, { encoding: "utf8" })),
                  (a = 3),
                  (s = i.split("\n")),
                  (c = Math.max(o - a, 0)),
                  (l = Math.min(s.length, o + a));
              } catch (n) {
                return (
                  (t.message +=
                    " - could not read from " + r + " (" + n.message + ")"),
                  void e(t, null, o)
                );
              }
              (a = s
                .slice(c, l)
                .map(function (e, t) {
                  var n = t + c + 1;
                  return (n == o ? "  > " : "    ") + n + "| " + e;
                })
                .join("\n")),
                (t.path = r);
              try {
                t.message =
                  (r || "Pug") + ":" + o + "\n" + a + "\n\n" + t.message;
              } catch (e) {}
              throw t;
            });
        },
        379: (e) => {
          "use strict";
          var t = [];
          function n(e) {
            for (var n = -1, r = 0; r < t.length; r++)
              if (t[r].identifier === e) {
                n = r;
                break;
              }
            return n;
          }
          function r(e, r) {
            for (var i = {}, a = [], s = 0; s < e.length; s++) {
              var c = e[s],
                l = r.base ? c[0] + r.base : c[0],
                u = i[l] || 0,
                p = "".concat(l, " ").concat(u);
              i[l] = u + 1;
              var m = n(p),
                f = {
                  css: c[1],
                  media: c[2],
                  sourceMap: c[3],
                  supports: c[4],
                  layer: c[5],
                };
              if (-1 !== m) t[m].references++, t[m].updater(f);
              else {
                var d = o(f, r);
                (r.byIndex = s),
                  t.splice(s, 0, { identifier: p, updater: d, references: 1 });
              }
              a.push(p);
            }
            return a;
          }
          function o(e, t) {
            var n = t.domAPI(t);
            return (
              n.update(e),
              function (t) {
                if (t) {
                  if (
                    t.css === e.css &&
                    t.media === e.media &&
                    t.sourceMap === e.sourceMap &&
                    t.supports === e.supports &&
                    t.layer === e.layer
                  )
                    return;
                  n.update((e = t));
                } else n.remove();
              }
            );
          }
          e.exports = function (e, o) {
            var i = r((e = e || []), (o = o || {}));
            return function (e) {
              e = e || [];
              for (var a = 0; a < i.length; a++) {
                var s = n(i[a]);
                t[s].references--;
              }
              for (var c = r(e, o), l = 0; l < i.length; l++) {
                var u = n(i[l]);
                0 === t[u].references && (t[u].updater(), t.splice(u, 1));
              }
              i = c;
            };
          };
        },
        569: (e) => {
          "use strict";
          var t = {};
          e.exports = function (e, n) {
            var r = (function (e) {
              if (void 0 === t[e]) {
                var n = document.querySelector(e);
                if (
                  window.HTMLIFrameElement &&
                  n instanceof window.HTMLIFrameElement
                )
                  try {
                    n = n.contentDocument.head;
                  } catch (e) {
                    n = null;
                  }
                t[e] = n;
              }
              return t[e];
            })(e);
            if (!r)
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              );
            r.appendChild(n);
          };
        },
        216: (e) => {
          "use strict";
          e.exports = function (e) {
            var t = document.createElement("style");
            return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
          };
        },
        565: (e, t, n) => {
          "use strict";
          e.exports = function (e) {
            var t = n.nc;
            t && e.setAttribute("nonce", t);
          };
        },
        795: (e) => {
          "use strict";
          e.exports = function (e) {
            var t = e.insertStyleElement(e);
            return {
              update: function (n) {
                !(function (e, t, n) {
                  var r = "";
                  n.supports && (r += "@supports (".concat(n.supports, ") {")),
                    n.media && (r += "@media ".concat(n.media, " {"));
                  var o = void 0 !== n.layer;
                  o &&
                    (r += "@layer".concat(
                      n.layer.length > 0 ? " ".concat(n.layer) : "",
                      " {"
                    )),
                    (r += n.css),
                    o && (r += "}"),
                    n.media && (r += "}"),
                    n.supports && (r += "}");
                  var i = n.sourceMap;
                  i &&
                    "undefined" != typeof btoa &&
                    (r +=
                      "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                        btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
                        " */"
                      )),
                    t.styleTagTransform(r, e, t.options);
                })(t, e, n);
              },
              remove: function () {
                !(function (e) {
                  if (null === e.parentNode) return !1;
                  e.parentNode.removeChild(e);
                })(t);
              },
            };
          };
        },
        589: (e) => {
          "use strict";
          e.exports = function (e, t) {
            if (t.styleSheet) t.styleSheet.cssText = e;
            else {
              for (; t.firstChild; ) t.removeChild(t.firstChild);
              t.appendChild(document.createTextNode(e));
            }
          };
        },
        835: () => {},
      },
      t = {};
    function n(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = (t[r] = { id: r, exports: {} });
      return e[r].call(i.exports, i, i.exports, n), i.exports;
    }
    (n.n = (e) => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return n.d(t, { a: t }), t;
    }),
      (n.d = (e, t) => {
        for (var r in t)
          n.o(t, r) &&
            !n.o(e, r) &&
            Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
      }),
      (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
      (n.nc = void 0);
    var r = {};
    return (
      (() => {
        "use strict";
        n.d(r, { default: () => U });
        var e = n(856),
          t = n(379),
          o = n.n(t),
          i = n(795),
          a = n.n(i),
          s = n(569),
          c = n.n(s),
          l = n(565),
          u = n.n(l),
          p = n(216),
          m = n.n(p),
          f = n(589),
          d = n.n(f),
          h = n(550),
          y = {};
        (y.styleTagTransform = d()),
          (y.setAttributes = u()),
          (y.insert = c().bind(null, "head")),
          (y.domAPI = a()),
          (y.insertStyleElement = m()),
          o()(h.Z, y);
        const g = h.Z && h.Z.locals ? h.Z.locals : void 0;
        var v = n(138),
          b = n.n(v);
        function x(e, t, n) {
          const { x: r, y: o } = e,
            { left: i, top: a } = n.getBoundingClientRect(),
            s = o - a,
            c = r - i + t.clientWidth > n.clientWidth,
            l = s + t.clientHeight > n.clientHeight;
          let u = r,
            p = o;
          return (
            c && (u = i + n.clientWidth - t.clientWidth),
            l && (p = a + n.clientHeight - t.clientHeight),
            { normalizedX: u, normalizedY: p }
          );
        }
        var T,
          w,
          E,
          k,
          S,
          N,
          A,
          M,
          C,
          O,
          L,
          _,
          I,
          D,
          R,
          H,
          F = function (e, t, n, r) {
            if ("a" === n && !r)
              throw new TypeError(
                "Private accessor was defined without a getter"
              );
            if ("function" == typeof t ? e !== t || !r : !t.has(e))
              throw new TypeError(
                "Cannot read private member from an object whose class did not declare it"
              );
            return "m" === n
              ? r
              : "a" === n
              ? r.call(e)
              : r
              ? r.value
              : t.get(e);
          };
        class j {
          constructor() {
            T.add(this),
              w.set(this, { style: g, menuItems: [] }),
              E.set(this, { transformOrigin: ["top", "left"] }),
              k.set(this, { theme: "black", transitionDuration: 200 }),
              (this.options = {}),
              S.set(this, (t) =>
                t.map(
                  (t) => (
                    "object" == typeof t &&
                      t.hasOwnProperty("iconHTML") &&
                      (t.iconHTML = (0, e.sanitize)(t.iconHTML)),
                    t
                  )
                )
              ),
              (this.applyStyleOnContextMenu = (e, t, n) => {
                e.style.transitionDuration = `${this.options.transitionDuration}ms`;
                const r = Array.from(this.options.transformOrigin);
                t && (r[1] = "right"),
                  n && (r[0] = "bottom"),
                  (e.style.transformOrigin = r.join(" ")),
                  this.options.customThemeClass
                    ? e.classList.add(this.options.customThemeClass)
                    : e.classList.add(
                        g[`context-menu--${this.options.theme}-theme`]
                      ),
                  this.options.customClass &&
                    e.classList.add(this.options.customClass);
              }),
              (this.buildContextMenu = () => {
                const e = document.createElement("div");
                return (e.innerHTML = b()(F(this, w, "f"))), e.children[0];
              });
          }
          updateOptions(e) {
            const t = F(this, S, "f").call(this, e.menuItems),
              n = F(this, T, "m", N).call(this, t);
            F(this, T, "m", A).call(this, n),
              Object.assign(this.options, F(this, k, "f")),
              Object.assign(
                this.options,
                Object.assign(Object.assign({}, e), { menuItems: n })
              ),
              Object.assign(this.options, F(this, E, "f")),
              (F(this, w, "f").menuItems = this.options.menuItems);
          }
        }
        (w = new WeakMap()),
          (E = new WeakMap()),
          (k = new WeakMap()),
          (S = new WeakMap()),
          (T = new WeakSet()),
          (N = function (e) {
            return (
              e
                .filter(
                  (e) => "object" == typeof e && e.hasOwnProperty("nestedMenu")
                )
                .map((e) => {
                  const t = e.callback;
                  e.callback = (n) => {
                    t && t(n),
                      new W(
                        Object.assign(Object.assign({}, this.options), {
                          menuItems: e.nestedMenu,
                        }),
                        n,
                        document.getElementById(`context-menu-item-${e._id}`)
                      );
                  };
                }),
              e
            );
          }),
          (A = function e(t) {
            t.filter((e) => "object" == typeof e).forEach((t, n) => {
              (t._id = Date.now() + n),
                t.nestedMenu && F(this, T, "m", e).call(this, t.nestedMenu);
            });
          });
        class W extends j {
          constructor(e, t, n) {
            super(),
              M.add(this),
              C.set(this, () => {
                var e;
                null ===
                  (e = document.querySelector(
                    `.${g["context-menu"]}.nested-context-menu`
                  )) ||
                  void 0 === e ||
                  e.remove();
              }),
              O.set(this, (e) => {
                this.options.menuItems.forEach((t, n) => {
                  "hr" !== t &&
                    t.callback &&
                    (e.children[n].onclick = () => {
                      var e, n, r;
                      t.callback(this.initialContextMenuEvent),
                        (null !==
                          (n =
                            null !== (e = t.preventCloseOnClick) && void 0 !== e
                              ? e
                              : this.options.preventCloseOnClick) &&
                          void 0 !== n &&
                          n) ||
                          (F(this, C, "f").call(this),
                          null ===
                            (r = document.querySelector(
                              `.${g["context-menu"]}`
                            )) ||
                            void 0 === r ||
                            r.remove());
                    });
                });
              }),
              this.updateOptions(e),
              F(this, M, "m", L).call(this, t, n);
          }
        }
        (C = new WeakMap()),
          (O = new WeakMap()),
          (M = new WeakSet()),
          (L = function (e, t) {
            (this.initialContextMenuEvent = e), F(this, C, "f").call(this);
            const n = this.buildContextMenu();
            n.classList.add("nested-context-menu"),
              document.querySelector("body").append(n),
              this.applyStyleOnContextMenu(n, !1, !1);
            const { x: r, y: o } = t.getBoundingClientRect();
            let { normalizedX: i, normalizedY: a } = x(
              { x: r, y: o },
              n,
              this.options.scope
            );
            i += n.clientWidth;
            const { x: s, y: c } = n.getBoundingClientRect(),
              { x: l, y: u } = (function () {
                const e = window,
                  t = document,
                  n = t.documentElement,
                  r = t.getElementsByTagName("body")[0];
                return {
                  x: e.innerWidth || n.clientWidth || r.clientWidth,
                  y: e.innerHeight || n.clientHeight || r.clientHeight,
                };
              })();
            s + n.clientWidth > l && (i -= 2 * n.clientWidth),
              c + n.clientHeight > u && (a -= n.clientHeight),
              a < 0 && (a = 0),
              (n.style.top = `${a}px`),
              (n.style.left = `${i}px`),
              (n.oncontextmenu = (e) => e.preventDefault()),
              F(this, O, "f").call(this, n),
              setTimeout(() => {
                n.classList.add(g.visible);
              });
          });
        class U extends j {
          constructor(e) {
            super(),
              _.set(this, () => {
                var e;
                F(this, I, "f").call(this),
                  null ===
                    (e = document.querySelector(`.${g["context-menu"]}`)) ||
                    void 0 === e ||
                    e.remove();
              }),
              I.set(this, () => {
                document
                  .querySelectorAll(`.${g["context-menu"]}.nested-context-menu`)
                  .forEach((e) => e.remove());
              }),
              D.set(this, (e) => {
                this.options.menuItems.forEach((t, n) => {
                  "hr" !== t &&
                    t.callback &&
                    (e.children[n].onclick = () => {
                      var e, n;
                      t.callback(this.initialContextMenuEvent),
                        (null !==
                          (n =
                            null !== (e = t.preventCloseOnClick) && void 0 !== e
                              ? e
                              : this.options.preventCloseOnClick) &&
                          void 0 !== n &&
                          n) ||
                          F(this, _, "f").call(this);
                    });
                });
              }),
              R.set(this, (e) => {
                e.preventDefault(),
                  e.stopPropagation(),
                  (this.initialContextMenuEvent = e),
                  F(this, _, "f").call(this);
                const t = this.buildContextMenu();
                document.querySelector("body").append(t);
                const { clientX: n, clientY: r } = e;
                let { normalizedX: o, normalizedY: i } = x(
                  { x: n, y: r },
                  t,
                  this.options.scope
                );
                i < 0 && (i = 0),
                  o < 0 && (o = 0),
                  (t.style.top = `${i}px`),
                  (t.style.left = `${o}px`),
                  this.applyStyleOnContextMenu(t, n !== o, r !== i),
                  (t.oncontextmenu = (e) => e.preventDefault()),
                  F(this, D, "f").call(this, t),
                  setTimeout(() => {
                    t.classList.add(g.visible);
                  });
              }),
              H.set(this, (e) => {
                e.target.closest(`.${g["context-menu"]}`) ||
                  F(this, _, "f").call(this);
              }),
              this.updateOptions(e),
              (this.options.scope.oncontextmenu = F(this, R, "f")),
              document.addEventListener("click", F(this, H, "f"));
          }
          off() {
            document.removeEventListener("click", F(this, H, "f")),
              (this.options.scope.oncontextmenu = null);
          }
        }
        (_ = new WeakMap()),
          (I = new WeakMap()),
          (D = new WeakMap()),
          (R = new WeakMap()),
          (H = new WeakMap());
      })(),
      r.default
    );
  })()
);
